























































































































































































































































































import { SearchBuilder } from "@/builder";
import { debounceProcess } from "@/helpers/debounce";
import { ResponsePagination } from "@/models/constant/interface/common.interface";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { Messages } from "@/models/enums/messages.enum";
import {
  CustomListCategory,
  DataListAssetBook,
  DataListAssetReclass,
  RequestPostReclass,
} from "@/models/interface/assets.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { assetsServices } from "@/services/assets.service";
import { ASSET_RECLASS_STATUS } from "@/types/AssetReclass";
import moment from "moment";
import Vue from "vue";

const ASSIGN_SEARCH_BUILDERS: Record<string, (value: any) => string> = {
  leasingNumber: value =>
    new SearchBuilder()
      .push(["leasing.leasingNumber", value], { like: "both" })
      .build(),
  unitCode: value =>
    new SearchBuilder()
      .push(["asset.unitCode", value], { like: "both" })
      .build(),
  serialNumber: value =>
    new SearchBuilder()
      .push(["asset.serialNumber", value], { like: "both" })
      .build(),
  status: value => new SearchBuilder().push(["status", value]).build(),
  reclassDate: value =>
    new SearchBuilder()
      .push(
        [
          "reclassDate",
          moment(value[0])
            .set({ hour: 0, minute: 0, second: 0 })
            .utcOffset("+07")
            .format(),
        ],
        { het: true }
      )
      .and()
      .push(
        [
          "reclassDate",
          moment(value[1])
            .set({ hour: 23, minute: 59, second: 59 })
            .utcOffset("+07")
            .format(),
        ],
        { let: true }
      )
      .build(),
  oldCategory: value =>
    new SearchBuilder().push(["oldAssetCategory.categoryId", value]).build(),
  newCategory: value =>
    new SearchBuilder().push(["newAssetCategory.categoryId", value]).build(),
};

export default Vue.extend({
  data() {
    this.getListNewCategory = debounceProcess(this.getListNewCategory, 200);
    this.getListOldCategory = debounceProcess(this.getListOldCategory, 200);
    return {
      DEFAULT_DATE_FORMAT,
      statusOptions: [
        {
          label: this.$t("lbl_pending"),
          value: ASSET_RECLASS_STATUS.PENDING,
        },
        {
          label: this.$t("lbl_approved"),
          value: ASSET_RECLASS_STATUS.APPROVED,
        },
        {
          label: this.$t("lbl_cancelled"),
          value: ASSET_RECLASS_STATUS.CANCELLED,
        },
      ],
      idBook: "" as string,
      dataListBook: [] as DataListAssetBook[],
      dataNewCategory: [] as CustomListCategory[],
      dataOldCategory: [] as CustomListCategory[],
      selectedRowKeys: [] as string[],
      dataSource: [] as DataListAssetReclass[],
      columnsTable: [
        {
          title: this.$t("lbl_leasing_number"),
          dataIndex: "leasingNumber",
          key: "leasingNumber",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_unit_code"),
          dataIndex: "unitCode",
          key: "unitCode",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_serial_number"),
          dataIndex: "serialNumber",
          key: "serialNumber",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_status"),
          dataIndex: "status",
          key: "status",
          width: 200,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_reclass_date"),
          dataIndex: "reclassDate",
          key: "reclassDate",
          width: 200,
          scopedSlots: { customRender: "isNull" },
        },
      ],
      visible: false as boolean,
      loadingModal: false as boolean,
      loadingListAssetBook: false as boolean,
      loadingOldCategory: false as boolean,
      loadingNewCategory: false as boolean,
      loading: false as boolean,
      loadingApprove: false as boolean,
      loadingFind: false as boolean,
      totalElements: 0 as number,
      page: 1 as number,
      limit: 10 as number,
      form: this.$form.createForm(this, { name: "Reclass" }),
      formModal: this.$form.createForm(this, { name: "Reclass Modal" }),
      formRulesModal: {
        reclassDate: {
          label: "lbl_reclass_date",
          name: "reclassDate",
          placeholder: "lbl_reclass_date_placeholder",
          decorator: [
            "reclassDate",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        newCategory: {
          label: "lbl_new_category",
          name: "newCategory",
          placeholder: "lbl_new_category_placeholder",
          decorator: [
            "newCategory",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
      formRules: {
        leasingNumber: {
          label: "lbl_leasing_number",
          name: "leasingNumber",
          placeholder: "lbl_leasing_number_placeholder",
          decorator: ["leasingNumber"],
        },
        status: {
          label: "lbl_status",
          name: "status",
          placeholder: "lbl_status_placeholder",
          decorator: ["status"],
        },
        unitCode: {
          label: "lbl_unit_code",
          name: "unitCode",
          placeholder: "lbl_unit_code_placeholder",
          decorator: ["unitCode"],
        },
        serialNumber: {
          label: "lbl_serial_number",
          name: "serialNumber",
          placeholder: "lbl_serial_number_placeholder",
          decorator: ["serialNumber"],
        },
        oldCategory: {
          label: "lbl_old_category",
          name: "oldCategory",
          placeholder: "lbl_old_category_placeholder",
          decorator: [
            "oldCategory",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        newCategory: {
          label: "lbl_new_category",
          name: "newCategory",
          placeholder: "lbl_new_category_placeholder",
          decorator: [
            "newCategory",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        reclassDate: {
          label: "lbl_reclass_date",
          name: "reclassDate",
          placeholder: "lbl_reclass_date_placeholder",
          decorator: [
            "reclassDate",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    moment,
    handlePopupApprove() {
      this.$confirm({
        title: this.$t("lbl_approve"),
        content: this.$t("confirmation.approve"),
        onOk: () => {
          this.handleApproveReclass();
        },
        onCancel() {
          return;
        },
      });
    },
    handleBook(idBook) {
      this.idBook = idBook;
      this.getListOldCategory("", idBook);
    },
    handleOpenModal() {
      this.visible = true;
    },
    getListAssetBook(valueSearch) {
      let params = {
        page: 0,
        limit: 10,
        search: `type~commercial_AND_active~true`,
      } as RequestQueryParamsModel;
      if (valueSearch) params.search += `_AND_name~*${valueSearch}*`;
      this.loadingListAssetBook = true;
      assetsServices
        .listAssetBook(params)
        .then(data => {
          this.dataListBook = data.data;
        })
        .finally(() => (this.loadingListAssetBook = false));
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.status !== ASSET_RECLASS_STATUS.PENDING,
        },
      };
    },
    responsePageSizeChange(response: ResponsePagination): void {
      this.limit = response.size;
      this.page = 1;
      this.submitForm();
    },
    responseCurrentPageChange(response: ResponsePagination): void {
      this.page = response.page;
      this.submitForm();
    },
    onSelectChange(value) {
      this.selectedRowKeys = value;
    },
    submitFormModal() {
      this.formModal.validateFields((err, res) => {
        if (err) return;
        this.loadingModal = true;

        const payload = {
          assetIds: this.selectedRowKeys,
          payload: {
            assetCategoryId: res.newCategory,
            reclassDate: res.reclassDate,
          },
        } as RequestPostReclass;
        assetsServices
          .createReclass(payload)
          .then(() => {
            this.$notification.success({
              description: Messages.CREATE_SUCCESS,
              message: "Success",
              duration: 30,
            });
            this.formModal.resetFields();
            // this.submitForm()
            this.totalElements = 0;
            this.form.resetFields();
            this.dataSource = [];
            this.visible = false;
          })
          .finally(() => (this.loadingModal = false));
      });
    },
    assignSearch(key, value, and): string {
      const builder = ASSIGN_SEARCH_BUILDERS[key];
      const hasValue =
        key === "reclassDate" ? value && value.length > 0 : !!value;
      if (!builder || !hasValue) return "";
      return and + builder(value);
    },
    dynamicSearch(res, paramsSearch): string {
      let search = paramsSearch;
      Object.keys(res).forEach(key => {
        if (!search) {
          search = this.assignSearch(key, res[key], "");
        } else {
          search += this.assignSearch(key, res[key], "_AND_");
        }
      });
      return search;
    },
    handleReset(): void {
      this.form.resetFields();
      this.selectedRowKeys = [];
      this.dataSource = [];
      this.totalElements = 0;
      this.page = 1;
    },
    handleApproveReclass() {
      this.loadingApprove = true;

      assetsServices
        .createReclassApprove({
          asset_reclass_secure_ids: this.selectedRowKeys,
        })
        .then(() => {
          this.submitForm();
        })
        .finally(() => {
          this.loadingApprove = false;
        });
    },
    submitForm() {
      this.form.validateFields((err, res) => {
        if (err) return;
        let params = {
          page: this.page - 1,
          limit: 10,
        } as RequestQueryParamsModel;

        params.search = this.dynamicSearch(res, params.search);

        this.loading = true;
        this.loadingFind = true;
        assetsServices
          .listAssetReclass(params)
          .then(data => {
            this.totalElements = data.totalElements;
            this.dataSource = data.data;
          })
          .finally(() => {
            this.loading = false;
            this.loadingFind = false;
          });
      });
    },
    handleCancel() {
      this.$router.push("/inquiry/find");
    },
    mapIdCategories(idCategories): string[] {
      return idCategories.map(dataMap => {
        let temp = dataMap.split("");
        if (temp.length > 0) {
          temp[0] = temp[0].toUpperCase();
          dataMap = temp.join("");
        }
        return dataMap;
      });
    },
    checkAndReturnString(value): string {
      if (value) return value;
      else return "";
    },
    getListOldCategory(value, idBook) {
      if (!idBook) {
        this.$notification.error({
          message: "Error",
          description: "Select Book First",
        });
      } else {
        let params = {
          page: 0,
          limit: 10,
          search: `book.secureId~*${idBook}*_AND_book.type~commercial_AND_categoryId~*.sgu*`,
        } as RequestQueryParamsModel;
        if (value) params.search += `_AND_categoryId~*${value}*`;
        this.loadingOldCategory = true;
        assetsServices
          .listAssetCategory(params)
          .then(response => {
            let tempDataSegments = [] as CustomListCategory[];
            response.data.forEach((data, index) => {
              let tempSegment = {
                id: data.id,
                accumulatedDepreciationAccountId: `${this.checkAndReturnString(
                  data.accumulatedDepreciationAccount.code
                )}-${data.accumulatedDepreciationAccount.description}`,
                depreciationAccount: `${this.checkAndReturnString(
                  data.depreciationExpenseAccount.code
                )}-${data.depreciationExpenseAccount.description}`,
                first: "",
                second: "",
                idForView: "",
                key: index,
              } as CustomListCategory;

              let idCategories = data.category.id.split(".");

              idCategories = this.mapIdCategories(idCategories);

              tempSegment.idForView = idCategories.join(".");
              tempDataSegments.push(tempSegment);
            });
            this.dataOldCategory = tempDataSegments;
          })
          .finally(() => (this.loadingOldCategory = false));
      }
    },
    getListNewCategory(value) {
      let params = {
        page: 0,
        limit: 10,
      } as RequestQueryParamsModel;
      if (value) params.search = `categoryId~*${value}*`;
      this.loadingNewCategory = true;
      assetsServices
        .listAssetCategory(params)
        .then(response => {
          let tempDataSegments = [] as CustomListCategory[];
          response.data.forEach((data, index) => {
            let tempSegment = {
              id: data.id,
              accumulatedDepreciationAccountId: `${
                data.accumulatedDepreciationAccount.code
                  ? data.accumulatedDepreciationAccount.code
                  : ""
              }-${data.accumulatedDepreciationAccount.description}`,
              depreciationAccount: `${
                data.depreciationExpenseAccount.code
                  ? data.depreciationExpenseAccount.code
                  : ""
              }-${data.depreciationExpenseAccount.description}`,
              first: "",
              second: "",
              idForView: "",
              key: index,
            } as CustomListCategory;

            let idCategories = data.category.id.split(".");

            idCategories = this.mapIdCategories(idCategories);

            tempSegment.idForView = idCategories.join(".");
            tempDataSegments.push(tempSegment);
          });
          this.dataNewCategory = tempDataSegments;
        })
        .finally(() => (this.loadingNewCategory = false));
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].componentOptions.children[1].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  created() {
    this.getListAssetBook("");
    this.getListNewCategory("");
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      };
    },
  },
});
